import React, { useState } from "react";
import { IconButton, List, ListItem, ListItemText } from "@mui/material";
import useMediaQuery from '@mui/material/useMediaQuery';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const ExpandableMenuButton = ({ name, titles, links, open, onClick }) => {
    const isMobile = useMediaQuery('(max-width: 768px)');

    return (
        <div className="menu-category-border">
            <div className="menu-category-title-row clickable-row" onClick={onClick}>
                <span className="menu-category-title">{name}</span>
                {isMobile && (
                    <IconButton size="small" className="expandable-icon-btn">
                        {open
                            ? <RemoveIcon className="expandable-icon" />
                            : <AddIcon className="expandable-icon" />
                        }
                    </IconButton>
                )}
            </div>
            {open && isMobile && (
                <List dense>
                    {titles.map((title, index) => (
                        <ListItem
                            key={title}
                            component="a"
                            href={links[index]}
                            className="expandable-list-item"
                        >
                            <ListItemText primary={title} />
                        </ListItem>
                    ))}
                </List>
            )}
        </div>
    );
};

export default ExpandableMenuButton;